module.exports = __webpack_public_path__ + "cf048894a34744abc0f40e867a3e0781.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/winking-15.png
// module id = 2280
// module chunks = 0